import {
    Container,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';

import * as S from './PageLayout.style';
import React from 'react';

import { DesignBoardPageContextProvider } from '../context/DesignBoardContext';
import MobileHeader from '~/modules/design-board/component/top-nav/MobileHeader';

interface PageLayoutProps extends React.PropsWithChildren {
    mainTitle?: string;
    subTitle?: string;
    backLink?: string;
    backLinkText?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
    children,
    mainTitle = 'DESIGN BOARDS',
    subTitle = '',
    backLink,
    backLinkText,
}) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();

    return (
        <div className={css(S.Page)}>
            <DesignBoardPageContextProvider>
                <Container>
                    {mobile ? (
                        <>
                            <MobileHeader
                                title={mainTitle}
                                subtitle={subTitle}
                                customBackUrl={backLink}
                                backLinkText={backLinkText}
                            />
                            <div className={css(S.MainContent)}>{children}</div>
                        </>
                    ) : (
                        <div className={css(S.MainContent)}>{children}</div>
                    )}
                </Container>
            </DesignBoardPageContextProvider>
        </div>
    );
};

export default PageLayout;
